module.exports = __webpack_public_path__ + "img/sony-headphones.88909ab5.jpg";